import { render, staticRenderFns } from "./ModelSelectButton.vue?vue&type=template&id=0966a60b&"
import script from "./ModelSelectButton.vue?vue&type=script&lang=js&"
export * from "./ModelSelectButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports